import { useState } from "react";
import { Container } from "react-bootstrap";
import { useParams } from "react-router-dom";

import { useSite } from "@inrange/building-manager-api-client";
import Loading from "../Loading";

import { SdmMatchConfig } from "@inrange/building-manager-api-client/models-site";
import SdmAddMatchModal from "./siteSections/SdmAddMatchModal";
import SdmAppliedMatches from "./siteSections/SdmAppliedMatches";
import SdmDeleteMatchModal from "./siteSections/SdmDeleteMatchModal";
import SdmOffers from "./siteSections/SdmOffers";
import SiteNav from "./siteSections/SiteNav";

const SiteSdm: React.FC = () => {
  const { siteId } = useParams<{ siteId: string }>();
  const { fetchSite, updateSite, siteAddMatch, siteDeleteMatch } = useSite({
    siteId,
    app: "admin",
  });
  const [selectedAddOffer, setSelectedAddOffer] = useState<
    SdmMatchConfig | undefined
  >(undefined);
  const [selectedDeleteOffer, setSelectedDeleteOffer] = useState<
    SdmMatchConfig | undefined
  >(undefined);

  if (fetchSite.isError) {
    return <div>Error loading the site.</div>;
  }

  if (fetchSite.isLoading || !fetchSite.data?.site) {
    return <Loading label="Loading site data..." />;
  }

  if (siteAddMatch.isError) {
    alert(`Error adding match - ${(siteAddMatch.error as Error).message}`);
    siteAddMatch.reset();
  }

  if (siteDeleteMatch.isError) {
    alert(`Error deleting match - ${(siteDeleteMatch.error as Error).message}`);
    siteDeleteMatch.reset();
  }

  const site = fetchSite.data?.site;

  document.title = `Site: ${site.name} - SDM`;

  const esysCount = Object.values(site.esys).filter((m) => !!m).length;

  return (
    <>
      <SiteNav />
      <Container fluid style={{ padding: "12px 12px 0px 12px" }} id="siteSdm">
        <fieldset disabled={fetchSite.data?.site.locked}>
          <div style={{ padding: "0 0 12px 0", fontSize: "26px" }}>
            {site.name}
          </div>
          {Object.values(site.esys)
            .filter((esys) => !!esys)
            .map((esys) => (
              <SdmAppliedMatches
                key={esys.idx}
                site={site}
                esys={esys}
                esysCount={esysCount}
                setSelectedDeleteOffer={setSelectedDeleteOffer}
              />
            ))}
        </fieldset>
        <SdmOffers
          site={site}
          updateSite={updateSite}
          setSelectedAddOffer={setSelectedAddOffer}
        />
        <fieldset disabled={fetchSite.data?.site.locked}>
          {selectedAddOffer !== undefined && (
            <SdmAddMatchModal
              site={site}
              selectedAddOffer={selectedAddOffer}
              setSelectedAddOffer={setSelectedAddOffer}
              siteAddMatch={siteAddMatch}
            />
          )}
          {selectedDeleteOffer !== undefined && (
            <SdmDeleteMatchModal
              site={site}
              selectedDeleteOffer={selectedDeleteOffer}
              setSelectedDeleteOffer={setSelectedDeleteOffer}
              siteDeleteMatch={siteDeleteMatch}
            />
          )}
        </fieldset>
      </Container>
    </>
  );
};

export default SiteSdm;
